import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import { Tooltip } from '@material-ui/core';

import BrIcons from '@components/BrIcons';
import BrLabel from '@components/BrLabel';
import BrTooltip from '@components/BrTooltip';

const READONLY_TOOLTIP_MULTISITE = (
  <div>
    This rule is read only because your current site context
    {' '}
    <br />
    (displayed at the right side of the top nav)
    {' '}
    <br />
    does not match the rule's site influence
  </div>
);
const READONLY_TOOLTIP_TESTING = 'This rule is read only because it is associated with an A/B test';

export default function EditorDeletableLinkTypeColumn({ row, col, cell }) {
  const { variants, isEditable, isLive, audiences } = row.Original_Data;
  const clickValue = cell.clickValue || cell.value;
  const isReadOnly = !isEditable || isLive;
  const isDeletable = !isReadOnly && variants === 1;
  const isColumnDisabled = cell.isColumnDisabled || false;
  const { tooltipText } = cell;

  const audience = audiences.length <= 0 ? null : (
    <BrLabel className="audience-name" preIcon={<BrIcons.Audience />} title={audiences[0].audienceName} />
  );

  const readOnlyNote = isReadOnly && (
    <BrTooltip className="read-only-label" location={BrTooltip.Locations.right}>
      Read Only
      <BrTooltip.Tooltip>{row.isLive.value ? READONLY_TOOLTIP_TESTING : READONLY_TOOLTIP_MULTISITE}</BrTooltip.Tooltip>
    </BrTooltip>
  );

  const deleteIcon = isDeletable && (
    <BrIcons.Delete className="del-row-icon" onClick={() => col.columnConfig.onDelete(row.Id.value)} />
  );

  const handleOnClick = () => (isColumnDisabled
    ? null
    : col.columnConfig.onClick(
      clickValue,
      row.Id.value,
      row.Type.value,
      false,
    ));

  const linkTypeClassName = cn('link-type-content', {
    disabled: isColumnDisabled,
  });

  const linkTypeContentWithoutHover = (
    <div className={linkTypeClassName}>
      {readOnlyNote}
      <div className="link-type-content-text">
        <div className="editor-type-text">{row.Type.value}</div>
        <a dir="auto" title={cell.value} onClick={handleOnClick}>
          {cell.value}
        </a>
      </div>
      {audience}
    </div>
  );

  const linkTypeContentWithHover = (
    <Tooltip title={tooltipText} placement="top-start">
      <span className="inherit-all">{linkTypeContentWithoutHover}</span>
    </Tooltip>
  );

  return (
    <div className="br-table-editor-deletable-link-type-column">
      {tooltipText ? linkTypeContentWithHover : linkTypeContentWithoutHover}
      {!isColumnDisabled && deleteIcon}
    </div>
  );
}

EditorDeletableLinkTypeColumn.defaultWidth = 240;

EditorDeletableLinkTypeColumn.propTypes = {
  cell: PropTypes.shape({
    // cell data
    value: PropTypes.string,
    isColumnDisabled: PropTypes.bool,
    tooltipText: PropTypes.string,
  }).isRequired,
  col: PropTypes.shape({
    // column config
    columnConfig: PropTypes.shape({
      onClick: PropTypes.func.isRequired, // (row, value:type) :=> {}
      onDelete: PropTypes.func.isRequired,
    }).isRequired,
  }).isRequired,
  row: PropTypes.shape({
    // row data
    Original_Data: PropTypes.shape({
      variants: PropTypes.any,
      isEditable: PropTypes.any,
      isLive: PropTypes.any,
    }).isRequired,
  }).isRequired,
};
